import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6b1e81a6")

_pushScopeId("data-v-6b1e81a6")
const _hoisted_1 = { class: "rank-container" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "content-title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "big"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "list-title" }, [
  /*#__PURE__*/_createVNode("span", null, "排名"),
  /*#__PURE__*/_createVNode("span", null, "用户名称"),
  /*#__PURE__*/_createVNode("span", null, "得分")
], -1)
const _hoisted_8 = { class: "content-list" }
const _hoisted_9 = { class: "item-left-wrapper" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "item-middle-wrapper" }
const _hoisted_12 = { class: "name" }
const _hoisted_13 = { class: "item-right-wrapper" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Back = _resolveComponent("Back")
  const _component_Title = _resolveComponent("Title")
  const _component_PopInner = _resolveComponent("PopInner")

  return (_openBlock(), _createBlock(_component_PopInner, {
    circleRight: true,
    circleTop: true,
    cup: true,
    flower: true,
    spot: true,
    starTop: true,
    starMiddle: true
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Back, { onAction: _ctx.goBack }, null, 8, ["onAction"]),
        _createVNode(_component_Title, {
          img: `${_ctx.rootUrl}/answer/rank_title.png`
        }, null, 8, ["img"]),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            (_ctx.rank && _ctx.rank > 0)
              ? (_openBlock(), _createBlock("span", _hoisted_4, "当前排名："))
              : _createCommentVNode("", true),
            (_ctx.rank && _ctx.rank > 0)
              ? (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.rank), 1))
              : (_openBlock(), _createBlock("span", _hoisted_6, "当前排名未上榜"))
          ]),
          _hoisted_7,
          _createVNode("div", _hoisted_8, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (i, k) => {
              return (_openBlock(), _createBlock("div", {
                class: "list-item",
                key: k
              }, [
                _createVNode("div", _hoisted_9, [
                  (k <= 2)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        src: `${_ctx.rootUrl}/answer/rank_${k + 1}.png`
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(k + 1), 1))
                ]),
                _createVNode("div", _hoisted_11, [
                  _createVNode("span", _hoisted_12, _toDisplayString(i.account_name), 1),
                  _createVNode("span", null, "上榜时间：" + _toDisplayString(i.create_time), 1)
                ]),
                _createVNode("div", _hoisted_13, [
                  _createVNode("span", null, _toDisplayString(i.grate), 1)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }))
})